export default __webpack_public_path__ + "static/Financing-107cf643ed904567f341f822d6ddf7f8.svg";